// ===================================
// TEASER SLIDER - OHNE REQUIRE/IMPORT
// ===================================

// @ts-nocheck

// KORRIGIERT: Alle require/import durch globale Variablen ersetzt
// const Flickity = require('../vendor/flickity'); // ← ENTFERNT
// import { $, $$ } from '../abstract/dom.js'; // ← ENTFERNT

// ===================================
// DOM HELPER FUNCTIONS
// ===================================

// Einfache DOM-Hilfsfunktionen (Ersatz für das import)
function $(selector, context = document) {
	return context.querySelector(selector)
}

function $$(selector, context = document) {
	return Array.from(context.querySelectorAll(selector))
}

// ===================================
// FLICKITY VERFÜGBARKEIT PRÜFEN
// ===================================

function initTeaserSliders() {
	// Prüfen ob Flickity global verfügbar ist
	if (typeof Flickity === 'undefined') {
		console.error('❌ Flickity nicht gefunden für Teaser Slider')
		console.log('💡 Stelle sicher, dass Flickity in vendor files geladen ist')
		return
	}
	
	console.log('🎠 Initialisiere Teaser Slider mit Flickity')
	
	// ===================================
	// TEASER SLIDER INITIALISIERUNG
	// ===================================
	
	$$('.teaser-slider').forEach(slider => {
		try {
			const flickityFlow = $('.flickity-flow', slider)
			
			if (!flickityFlow) {
				console.warn('⚠️ .flickity-flow nicht gefunden in', slider)
				return
			}
			
			console.log('🔧 Initialisiere Flickity für:', slider)
			
			const flkty = new Flickity(flickityFlow, {
				contain: true,
				cellAlign: 'left',
				adaptiveHeight: true,
				prevNextButtons: slider.dataset.prevNext === 'true', // String zu Boolean
				watchCSS: true,
				accessibility: false,
				groupCells: true,
				on: {
					ready() {
						console.log('✅ Flickity ready für:', slider)
						
						if (this.options.prevNextButtons) {
							// Defensive Programmierung
							if (this.prevButton && this.prevButton.element) {
								this.prevButton.element.tabIndex = -1
							}
							if (this.nextButton && this.nextButton.element) {
								this.nextButton.element.tabIndex = -1
							}
						}
					},
				},
				
			})
			
			// ===================================
			// FOCUS EVENT HANDLERS
			// ===================================
			
			flkty.element.addEventListener('focusin', event => {
				event.preventDefault()
				
				// Pausiere Player falls verfügbar
				if (typeof flkty.pausePlayer === 'function') {
					flkty.pausePlayer()
				}
				
				// Finde die nächste Cell
				const cellElement = event.target.closest('.cell')
				
				if (cellElement && flkty.isActive) {
					const cellInstance = flkty.getCell(cellElement)
					
					if (cellInstance) {
						const cellIndex = flkty.getCellSlideIndex(cellInstance)
						
						if (cellIndex !== flkty.selectedIndex && cellIndex !== -1) {
							flkty.select(cellIndex, false, true)
						}
					}
				}
				
				// Focus mit preventScroll (falls unterstützt)
				if (event.target && event.target.focus) {
					try {
						event.target.focus({
							preventScroll: true,
						})
					} catch (error) {
						// Fallback für ältere Browser
						event.target.focus()
					}
				}
			})
			
			flkty.element.addEventListener('focusout', event => {
				// Unpause Player falls verfügbar
				if (typeof flkty.unpausePlayer === 'function') {
					flkty.unpausePlayer()
				}
			})
			
			// ===================================
			// DEBUGGING INFO
			// ===================================
			
			// ===================================
			// DEBUGGING INFO
			// ===================================
			
			console.log('✅ Teaser Slider erfolgreich initialisiert:', {
				element: slider,
				cells: flkty.cells ? flkty.cells.length : 0,  // ← FIX: Prüfe ob cells existiert
				prevNextButtons: flkty.options.prevNextButtons,
				groupCells: flkty.options.groupCells
			})
			
		} catch (error) {
			console.error('❌ Fehler beim Initialisieren des Teaser Sliders:', error)
			console.error('   Slider Element:', slider)
		}
	})
}

// ===================================
// ALTERNATIVE: MIT TWEEN INTEGRATION
// ===================================

function initTeaserSlidersWithTween() {
	// Falls Sie später Tween/GSAP integrieren möchten:
	if (typeof Tween !== 'undefined') {
		console.log('🎬 GSAP/Tween verfügbar für erweiterte Animationen')
		
		// Beispiel: Custom Slide-Transition
		$$('.teaser-slider').forEach(slider => {
			const flkty = Flickity.data(slider.querySelector('.flickity-flow'))
			
			if (flkty) {
				flkty.on('change', function(index) {
					// Custom GSAP Animation
					const selectedCell = flkty.selectedElement
					if (selectedCell) {
						Tween.fromTo(selectedCell, 0.3, 
							{ opacity: 0.7, scale: 0.95 },
							{ opacity: 1, scale: 1 }
						)
					}
				})
			}
		})
	}
}

// ===================================
// RESPONSIVE HANDLING
// ===================================

function handleTeaserSliderResize() {
	$$('.teaser-slider').forEach(slider => {
		const flickityFlow = $('.flickity-flow', slider)
		if (flickityFlow) {
			const flkty = Flickity.data(flickityFlow)
			if (flkty) {
				flkty.resize()
			}
		}
	})
}

// Resize Event
window.addEventListener('resize', debounce(handleTeaserSliderResize, 250))

// Debounce Hilfsfunktion
function debounce(func, wait) {
	let timeout
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout)
			func(...args)
		}
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
	}
}

// ===================================
// INITIALISIERUNG
// ===================================

// DOM Ready Check
function initWhenReady() {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			console.log('🎠 DOM Ready - Initialisiere Teaser Sliders')
			initTeaserSliders()
			initTeaserSlidersWithTween() // Optional
		})
	} else {
		// DOM bereits geladen
		console.log('🎠 DOM bereits geladen - Initialisiere Teaser Sliders sofort')
		initTeaserSliders()
		initTeaserSlidersWithTween() // Optional
	}
}

// Warten auf Flickity falls noch nicht geladen
if (typeof Flickity !== 'undefined') {
	initWhenReady()
} else {
	// Polling für Flickity
	let attempts = 0
	const maxAttempts = 50
	
	const waitForFlickity = setInterval(() => {
		attempts++
		
		if (typeof Flickity !== 'undefined') {
			clearInterval(waitForFlickity)
			console.log('✅ Flickity geladen nach', attempts, 'Versuchen')
			initWhenReady()
		} else if (attempts >= maxAttempts) {
			clearInterval(waitForFlickity)
			console.error('❌ Flickity konnte nicht geladen werden nach', maxAttempts, 'Versuchen')
		}
	}, 100)
}

// ===================================
// DEBUGGING HILFSFUNKTIONEN
// ===================================

// Global verfügbare Debug-Funktion
window.debugTeaserSliders = function() {
	console.group('🔍 Teaser Slider Debug')
	
	const sliders = $$('.teaser-slider')
	console.log('Gefundene Slider:', sliders.length)
	
	sliders.forEach((slider, index) => {
		const flickityFlow = $('.flickity-flow', slider)
		const flkty = flickityFlow ? Flickity.data(flickityFlow) : null
		
		console.log(`Slider ${index}:`, {
			element: slider,
			flickityFlow: !!flickityFlow,
			flickityInstance: !!flkty,
			cells: (flkty && flkty.cells) ? flkty.cells.length : 'N/A',  // ← FIX
			isActive: flkty ? flkty.isActive : 'N/A'
		})
	})
	
	console.groupEnd()
}

// Automatischer Debug nach Initialisierung
setTimeout(() => {
	if (typeof window.debugTeaserSliders === 'function') {
		window.debugTeaserSliders()
	}
}, 2000)